import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Child(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M15.447 2.894a1 1 0 10-.894-1.788c-1.312.655-2.317 1.515-2.918 2.544-.588-.63-1.393-1.29-2.319-1.599a1 1 0 10-.632 1.898c.515.171 1.084.612 1.571 1.156.03.032.058.065.086.097-3.055.672-5.584 2.957-6.456 5.934a2.501 2.501 0 000 4.728C4.929 19.427 8.347 22 12.2 22a8.503 8.503 0 008.167-6.136 2.501 2.501 0 000-4.728 8.508 8.508 0 00-7.192-6.081c.297-.775.999-1.524 2.272-2.16zM5.68 12.2C6.277 9.256 9.032 7 12.2 7a6.503 6.503 0 016.37 5.199 1 1 0 00.98.801.5.5 0 010 1 1 1 0 00-.98.801A6.503 6.503 0 0112.2 20c-3.168 0-5.923-2.256-6.52-5.199A1 1 0 004.7 14a.5.5 0 010-1 1 1 0 00.98-.801zM11 13a1 1 0 11-2 0 1 1 0 012 0zm4 1a1 1 0 100-2 1 1 0 000 2z",
    clipRule: "evenodd"
  }));
}

export default Child;